// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"WL-z","loadingMedia":"XL-z","reviewsImagesAndVideos":"YL-z","limitHeight":"ZL-z"};